import React from 'react';
import { Navigate } from 'react-router-dom';

import { URL } from './constants';
import { useUserStore } from './stores/user';

export const PrivateRoute = (props: {
  children: React.ReactNode;
  allowAssignee?: boolean;
}) => {
  const { children, allowAssignee } = props;

  const { accessToken } = useUserStore();
  const assigneeData = JSON.parse(localStorage.getItem('assigneeData') ?? '{}');

  // if user is NOT authenticated & it's not assignee access
  if (!accessToken && (!allowAssignee || !assigneeData.hasAccess)) {
    // save page URL in localStorage – to redirect back after login
    const { pathname, search } = window.location;
    localStorage.setItem('previousPage', pathname + search);

    // redirect to Enter Email
    return <Navigate to={URL.ENTER_EMAIL} />;
  }

  return children;
};

export const PublicRoute = (props: { children: React.ReactNode }) => {
  const { children } = props;

  const { accessToken, isLoggingIn } = useUserStore();

  // if user is authenticated & not logging in – redirect to Home
  if (accessToken && !isLoggingIn) return <Navigate to={URL.HOME} />;

  return children;
};
